export const KD_CONFIG_KEY = '__KD_CONFIG__'
export const KD_CONFIG_ADDRESS_KEY = 'addresses'
export const KD_RELEASE_KEY = 'release'